import { useState } from "react";
import { MapPin } from "lucide-react";
import Container from "@/components/ui/Container";

type Tab = "all" | "popular" | "recent";

const PUBLIC_PLANS = [
  {
    title: "4 Days Plan for Lakshadweep",
    location: "Lakshadweep",
    image:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: ["popular"] as string[],
  },
  {
    title: "5 Days Plan in Bali",
    location: "Bali",
    image:
      "https://images.unsplash.com/photo-1537996194471-e657df975ab4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: ["popular"] as string[],
  },
  {
    title: "5 Days Plan in Manali",
    location: "Manali",
    image:
      "https://images.unsplash.com/photo-1605640840605-14ac1855827b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: ["popular"] as string[],
  },
  {
    title: "3 Days Plan for Paris",
    location: "Paris",
    image:
      "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: ["recent"] as string[],
  },
  {
    title: "7 Days Plan in Tokyo",
    location: "Tokyo",
    image:
      "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: ["recent"] as string[],
  },
  {
    title: "4 Days Plan in Santorini",
    location: "Santorini",
    image:
      "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: ["recent"] as string[],
  },
  {
    title: "6 Days Plan in Swiss Alps",
    location: "Switzerland",
    image:
      "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: ["popular", "recent"] as string[],
  },
  {
    title: "3 Days Plan in Dubai",
    location: "Dubai",
    image:
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    tags: ["popular"] as string[],
  },
  {
    title: "5 Days Plan in Maldives",
    location: "Maldives",
    image:
      "/images/5_day_plan.png",
    tags: ["recent"] as string[],
  },
];

const TABS: { label: string; value: Tab }[] = [
  { label: "All", value: "all" },
  { label: "Popular", value: "popular" },
  { label: "Recent", value: "recent" },
];

export function PopularPublicPlans() {
  const [activeTab, setActiveTab] = useState<Tab>("all");

  const filtered =
    activeTab === "all"
      ? PUBLIC_PLANS
      : PUBLIC_PLANS.filter((p) => p.tags.includes(activeTab));

  return (
    <section className="py-12 bg-[#FDF9F5]">
      <Container>
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-[#0F766E] text-2xl font-bold">
            Popular Public Plans
          </h2>
          <div className="flex gap-1">
            {TABS.map((tab) => (
              <button
                key={tab.value}
                onClick={() => setActiveTab(tab.value)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${activeTab === tab.value
                    ? "bg-[#ED6F2E] text-white"
                    : "text-slate-600 hover:text-slate-800 hover:bg-slate-100"
                  }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {filtered.map((plan, idx) => (
            <div
              key={idx}
              className="bg-white rounded-[16px] overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer border border-[#EDE8E3]"
            >
              <div className="h-[180px] w-full overflow-hidden">
                <img
                  src={plan.image}
                  alt={plan.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                />
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-[15px] text-slate-800 mb-1 line-clamp-1">
                  {plan.title}
                </h3>
                <div className="flex items-center text-xs text-slate-500 gap-1">
                  <div className="w-2 h-2 bg-[#ED6F2E]" />
                  {plan.location}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Tiny dots indicator below */}
        <div className="flex justify-center mt-8 gap-2">
          <div className="w-[16px] h-[3px] bg-[#EDE8E3] rounded-full" />
          <div className="w-[32px] h-[3px] bg-[#ED6F2E] rounded-full" />
          <div className="w-[16px] h-[3px] bg-[#EDE8E3] rounded-full" />
        </div>
      </Container>
    </section>
  );
}
